module.exports = __webpack_public_path__ + "img/banner21.436a89dc.png";